import React from 'react'
import PropTypes from 'prop-types'
import EmailInput from './EmailInput'

export default function FormGroup({data, onChange, enteredUserData = {}}) {

    let { validated, errorText } = enteredUserData;
    let validationData = '';
    if (validated) {
        validationData = errorText ? 'is-invalid' : 'is-valid';
    }

    const props = {
        name:  data.key,
        id: 'dc-' + data.key,
        maxLength: data.maxLength,
        className: `form-control ${validationData}`,
        'data-test-id': 'f6504b3a-0705-' + data.key,
        onChange
    }

    return <div className="input-group has-validation mb-3">

        <div className="form-floating">
            {getInput(data.type, props)}
            <label htmlFor={props.id} data-test-id={'698596bc-2be2' + data.key}>
                {data.display} {data.mandatory || <small>(optional)</small>}
            </label>
            <div className="invalid-feedback">
                {enteredUserData.errorText}
            </div>
        </div>
    </div>
}

FormGroup.propTypes = {
    data: PropTypes.shape({
        key: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        display: PropTypes.string.isRequired,
        mandatory: PropTypes.bool,
        maxLength: PropTypes.number,
        sortKey: PropTypes.number.isRequired,
        choices: PropTypes.array
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    enteredUserData: PropTypes.shape({
        validated: PropTypes.bool,
        validationMessage: PropTypes.string
    }),
    id: PropTypes.string
}

function getInput(fieldType, props) {
    if (fieldType === 'email') {
        return <EmailInput {...props} placeholder="" />;
    } else {
        return <input type="text" {...props} placeholder="" onChange={e => props.onChange(e.target.value)} />;
    }
}